// extracted by mini-css-extract-plugin
module.exports = {"vinkaSuperContainer":"Layout_vinkaSuperContainer__1dwO7","grid":"Layout_grid__2QTx_"};